import {ProofSuccessScreen} from './ProofSuccess';
import {SendSuccessScreen} from './SendSuccess';
import {RemoveSuccessScreen} from './RemoveSuccess';
import {SalesmanNewClientRequestSuccess} from './SalesmanNewClientRequestSuccess';
export {
  ProofSuccessScreen,
  SendSuccessScreen,
  RemoveSuccessScreen,
  SalesmanNewClientRequestSuccess,
};
